import React from "react";
import DailyGoalCard from "./DailyGoalCard";
import DailyGoalStreakCard from "./DailyGoalStreakCard";

const DailyGoalCards = ({
  goalSummary = "",
  progressPercent = 0,
  streakDays = 0,
  streakLabel = "Daily Goal Streak",
  fireIconUrl,
  onEditGoal,
  onOpenStreak,
}) => {
  return (
    <div className="study-dashboard__goal-row">
      <DailyGoalCard
        goalSummary={goalSummary}
        progressPercent={progressPercent}
        onEditGoal={onEditGoal}
      />

      <DailyGoalStreakCard
        streakDays={streakDays}
        streakLabel={streakLabel}
        fireIconUrl={fireIconUrl}
        onOpenStreak={onOpenStreak}
      />
    </div>
  );
};

export default DailyGoalCards;
